/* eslint-disable camelcase */
import React, { Component } from 'react';
import { Dialog, IconButton } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Fade from '@material-ui/core/Fade';
import Slide from '@material-ui/core/Slide';
import { StyleSheet, css } from 'aphrodite';
import { Helper } from '../helpers/Helper';
import { CommonTheme } from '../../styles/Styles';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { AppHelper } from '../../helpers/AppHelper';
import { DynamicForm } from './DynamicForm';
import { ApiHelper } from '../helpers/ApiHelper';

function getCustomNumberRangeFieldDef(startValue, endValue, rangeOptions) {
  const hasRangeOptions = Array.isArray(rangeOptions) && rangeOptions.length > 0
  const fields = []
  if (hasRangeOptions) {
    fields.push({
      key: 'selectedBand',
      type: 'radio',
      label: 'Preset Range',
      hint: 'Select a range',
      v_required: { value: false, err: 'Select a range' },
      placement: 'left',
      fullWidth: true,
      options: [
        ...rangeOptions.map((opt) => ({
          key: opt.key,
          label: opt.label || opt.key,
        })),
        { key: '__custom__', label: 'Custom range' },
      ],
    })
  }
  const customRangeCondition = hasRangeOptions
    ? { key: 'selectedBand', value: '__custom__', values: ['__custom__'] }
    : null
  fields.push(
    {
      key: 'startValue',
      type: 'edit_text',
      label: 'Start Value',
      hint: 'Select start value',
      v_required: { value: false, err: 'Select start value' },
      placement: 'left',
      ...(customRangeCondition ? { condition: customRangeCondition } : {}),
    },
    {
      key: 'endValue',
      type: 'edit_text',
      label: 'End Value',
      hint: 'Select end value',
      v_required: { value: false, err: 'Select end value' },
      placement: 'right',
      ...(customRangeCondition ? { condition: customRangeCondition } : {}),
    },
  )
  const customNumberRangeFieldDef = {
    steps: [
      {
        fields,
      }
    ]
  }
  let selectedBand = ''
  if (hasRangeOptions) {
    const matched = rangeOptions.find((opt) => {
      const fromMatch = String(opt.from != null ? opt.from : '') === String(startValue != null ? startValue : '')
      const toMatch = String(opt.to != null ? opt.to : '') === String(endValue != null ? endValue : '')
      return fromMatch && toMatch && (opt.from != null || opt.to != null)
    })
    if (matched) {
      selectedBand = matched.key
    } else if (startValue != null || endValue != null) {
      selectedBand = '__custom__'
    }
  }
  Helper.populateFormDefinitionValues(customNumberRangeFieldDef, {
    selectedBand,
    startValue: startValue,
    endValue: endValue,
  })
  return customNumberRangeFieldDef
}

function generateDisplayText({ startValue, endValue, rangeOptions }) {
  if (Array.isArray(rangeOptions) && rangeOptions.length > 0) {
    const matched = rangeOptions.find((opt) => {
      const fromMatch = String(opt.from != null ? opt.from : '') === String(startValue != null ? startValue : '')
      const toMatch = String(opt.to != null ? opt.to : '') === String(endValue != null ? endValue : '')
      return fromMatch && toMatch && (opt.from != null || opt.to != null)
    })
    if (matched) return matched.label || matched.key
  }
  if (startValue && endValue) {
    return `Ranging from ${startValue} to ${endValue}`
  }
  if (startValue) {
    return `Greater than or equal to ${startValue}`
  }
  if (endValue) {
    return `Less than or equal to ${endValue}`
  }
  return 'All'
}


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class NumberRangePicker extends Component {
  constructor(props) {
    super(props)
    this.isMobileView = Helper.isMobileView()
    this.state = {
      isOpen: false,
      startValue: props.initialRange && props.initialRange.startValue,
      endValue: props.initialRange && props.initialRange.endValue
    }
  }

  openNumberRangePicker = () => {
    if (this.props.disabled) return;
    this.apiData = {
      isCustomNumberRange: true,
    }
    this.formDefinition = getCustomNumberRangeFieldDef(
      this.state.startValue,
      this.state.endValue,
      this.props.rangeOptions
    )
    this.formDefinition.formType = 'edit'
    this.formDefinition.ctaButtonText = 'Apply'
    this.setState({
      isOpen: true,
    })
  }
  closeNumberRangePicker = () => {
    this.setState({
      isOpen: false,
    });
  }

  async customSubmit(options) {
    const { formType, formData, caller } = options
    if (formData.isCustomNumberRange) { return this.customSubmitForNumberRange(options) }
    return caller.submit.call(caller, formData, true);
  }

  async customSubmitForNumberRange(options) {
    const { formType, formData, caller } = options
    delete formData.isCustomNumberRange

    const rangeOptions = this.props.rangeOptions || []
    let startValue = formData.startValue
    let endValue = formData.endValue
    if (formData.selectedBand && formData.selectedBand !== '__custom__') {
      const band = rangeOptions.find((opt) => opt && String(opt.key) === String(formData.selectedBand))
      if (band) {
        startValue = band.from != null ? String(band.from) : ''
        endValue = band.to != null ? String(band.to) : ''
      }
    }

    let numberFieldTypeError = null
    if (startValue && endValue && isNaN(startValue) && isNaN(endValue)) {
      numberFieldTypeError = Helper.getString('numberFieldTypeError')
    } else if (startValue && isNaN(startValue)) {
      numberFieldTypeError = Helper.getString('numberFieldStartTypeError')
    } else if (endValue && isNaN(endValue)) {
      numberFieldTypeError = Helper.getString('numberFieldEndTypeError')
    }

    if(numberFieldTypeError) {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        success: false,
        message: numberFieldTypeError,
        inProcess: false
      })
    } else if(startValue && endValue && (Number(startValue) > Number(endValue))) {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        success: false,
        message: Helper.getString('numberRangeErr'),
        inProcess: false
      })
    } else {
      this.setState({
        startValue,
        endValue,
        isOpen: false,
      })
      if (this.props.onNumberRangeChange) {
        this.props.onNumberRangeChange({
          startValue,
          endValue,
        })
      }
    }
  }


  render() {
    const {  startValue, endValue  } = this.state
    const displayText = generateDisplayText({
      startValue,
      endValue,
      rangeOptions: this.props.rangeOptions,
    })

    const modalTitle = this.props.title || 'Pick Range'
    return (
      <div>
        <div className={this.props.disabled ? css(Styles.displayField, Styles.numberRangePickerStyle, Styles.displayFieldDisabled) : css(Styles.displayField, Styles.numberRangePickerStyle)} onClick={!this.props.disabled && this.openNumberRangePicker}>
          {displayText}
          <IconButton size='small' className={css(Styles.arrowButton)} disabled={this.props.disabled}>
            {this.state.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </IconButton>
        </div>

        <Dialog
          open={this.state.isOpen}
          aria-labelledby={modalTitle}
          TransitionComponent={window.innerWidth < 768 ? Transition : Fade}
          classes={{
            root: css(Styles.customRoot),
            paper: css(Styles.customPaper, AppHelper.isDialogScrollbarEnabled() && AppStyles.dialogScrollbar),
          }}
        >
          <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
            <div className={css(Styles.modalTitle)}>{modalTitle}</div>
            <button className={css(Styles.modalCloseButton)} onClick={this.closeNumberRangePicker} disabled={this.state.inProcess}>
              <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
                <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
              </svg>
            </button>
          </div>
          <div className={css(Styles.modalContent)}>
            <DynamicForm
              apiData={this.apiData}
              formDefinition={this.formDefinition}
              customSubmit={this.customSubmit.bind(this)}
              fullWidthFieldsFirst={Array.isArray(this.props.rangeOptions) && this.props.rangeOptions.length > 0}
            />
          </div>

        </Dialog>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  displayField: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    minWidth: 200,
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden',
    boxSizing: 'border-box',
    padding: '12px 0px 12px 20px',
    color: CommonTheme.textColor,
    fontSize: 16,
    fontWeight: 'initial',
    '@media (max-width: 1024px)': {
      fontSize: 10,
      minWidth: 0,
      width: 150,
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
  displayFieldDisabled: {
    backgroundColor: AppTheme.secondaryColor,
    color: '#808080',
  },
  arrowButton: {
    marginLeft: 'auto',
    // '@media (max-width: 1024px)': {
    padding: 0,
    // }
  },
  modalHeader: {
    // backgroundColor: 'whitesmoke',
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: 20,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
    }
  },
  modalTitle: {
    color: CommonTheme.textColor,
    fontSize: 26,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // marginRight: 28,
    flex: 1,
    '@media (max-width: 767px)': {
      fontSize: 20,
      marginRight: 43,
    }
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: 30,
    paddingRight: 30,
    minWidth: 500,
    '@media (max-width: 767px)': {
      minWidth: 'unset',
      paddingLeft: 15,
      paddingRight: 15,
    }
  },
  modalCloseButton: {
    // position: 'absolute',
    // top: 23,
    // right: 30,
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    border: 'none'
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    border: '1.5px solid' + AppTheme.primaryColor,
    fill: AppTheme.primaryColor,
    borderRadius: 8
  },
  button: {
    boxShadow: 'none',
    marginLeft: 10,
    backgroundColor: AppTheme.primaryColor,
  },
  customRoot: {
    zIndex: 13000
  },
  customPaper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 767px)': {
      // borderRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      width: '100%',
      bottom: 0,
      position: 'fixed',
      margin: 0,
      marginTop: 0,
      maxHeight: '100%'
    },
    '::-webkit-scrollbar': {
      display: 'none'
    },
  },
  numberRangePickerStyle: {
    padding: '15px 6px 15px 20px',
    '@media (max-width: 1024px)': {
      width: '100%',
      fontSize: 16,
      paddingTop: 15,
      paddingBottom: 15,
    },
  },
})
